import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import Icon from '~/components/base/Icon';

import { formatText, dynamicFontSize } from '~/utilities/helpers';

import { kebabCase } from 'lodash';

const List = styled.ul`
    list-style: none;
    padding: 0;

    @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
        column-count: ${({ columns }) => columns};
    }
`;

const Item = styled.li`
    font-size: ${dynamicFontSize(1.4, 1.7, 2.2)};
    font-family: ${({ theme }) => theme.fonts.heading};
    font-weight: ${({ theme }) => theme.fontWeights.bold};
    line-height: 1.29;
    display: flex;
    align-items: flex-start;
    break-inside: avoid;

    &:not(:last-of-type) {
        margin-bottom: 10px;
    }
`;

const StyledIcon = styled(Icon)`
    margin-right: 10px;
    margin-top: 2px;
    flex-shrink: 0;

    @media (min-width: ${({ theme }) => theme.breakpoint.largeDesktop}) {
        margin-top: 4px;
    }
`;

const CheckList = ({ items, columns = 2 }) => (
    <List {...{ columns }}>
        {items.map((item) => (
            <Item key={kebabCase(item)}>
                <StyledIcon
                    icon="checkmark"
                    size={17}
                    sizeMobile={12}
                    color="yellow"
                />
                <div>{formatText(item)}</div>
            </Item>
        ))}
    </List>
);

CheckList.propTypes = {
    items: PropTypes.arrayOf(PropTypes.string).isRequired,
    columns: PropTypes.number
};

export default CheckList;
